module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.cateData == 'CmsCate') ? _c('cms-cate') : (_vm.cateData == 'CmsList') ? _c('cms-list') : (_vm.cateData == 'TextList') ? _c('text-list') : (this.$route.query.id.toString().indexOf('course') > -1) ? _c('course-list') : (_vm.cateData == 'CateSinglePage') ? _c('cate-single-page') : (_vm.cateData == 'CmsQualificationsSearch') ? _c('cms-qualifications-search') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6520f7f1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/cms/cate.vue
// module id = 1265
// module chunks = 0